import React from 'react';
import { LeaderboardSponsorLogo } from './leaderboard-sponsor-logo';


const LeaderboardHeader = ({children}) => {
    return (
        <section>
            <div className="banner-container banner-after blackbanner black-banner center-align">
                <div class="wrapper">
                    <div class="row">
                        <div className="col l12 m12 s12">
                            <div className="banner-content-area">
                                <h1 class="heading">Leaderboards</h1>
                                <LeaderboardSponsorLogo />
                                {children}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default LeaderboardHeader;